// extracted by mini-css-extract-plugin
export default {"storyTimeline":"c-a_gr","storyTimeline__item":"c-a_gs","storyTimeline__item_complete":"c-a_gt","storyTimeline__item_withProgress":"c-a_gu"};